import { CUSTOM_OKTA_STORAGE_KEY } from '../../login/constant';
import { getAppConfig } from '../utilities/configUtils';

const { host, path } = getAppConfig('server');

const basePath = `${host}${path}`;

const oktaConfig = (() => {
  const { clientId = '', baseUrl = '', issuerPath = '', redirectUri = '', samlId = '' } = getAppConfig('oktaOIDC');

  const config = {
    issuer: `${baseUrl}${issuerPath}`,
    clientId,
    redirectUri: `${basePath}${redirectUri}`,

    tokenManager: {
      storage: 'cookie',
      // storage key
      // this is a randomly generated namespace
      // you should namespace your application's okta storage properties
      // so it does not clobber other applications
      storageKey: CUSTOM_OKTA_STORAGE_KEY
    },
    scopes: ['openid', 'profile', 'email', 'offline_access'],
    baseUrl,
    devMode: false,
    cookies: {
      secure: true
    },
    pkce: false,
    postLogoutRedirectUri: `${baseUrl}/login`,
    redirectAfterLogin: '/dashboard',
    idps: [
      {
        type: 'saml',
        id: samlId,
        text: 'Sign In As Employee',
        className: 'cargill-identity'
      }
    ]
  };

  // eslint-disable-next-line camelcase
  window.__okta_config__ = config;

  return config;
})();

const buildWidgetOptions = (labels, language) => {
  const { baseUrl, clientId, issuer, pkce, redirectUri, scopes, idps } = oktaConfig;
  const { i18n, employeeSignIn } = labels;
  idps[0].text = employeeSignIn;

  const oktaLang = language.toLowerCase() === 'pt' ? 'pt_BR' : language;

  return {
    issuer,
    clientId,
    redirectUri,
    useClassicEngine: true,
    idps,
    authParams: {
      issuer,
      scopes,
      pkce
    },
    logo: '/food/logo.png',
    language: oktaLang,
    baseUrl,
    helpLinks: {
      custom: [
        {
          text: i18n[language].cargillSignIn
        }
      ]
    },
    i18n,
    assets: {
      rewrite: assetPath => {
        if (assetPath.includes('labels')) {
          return '';
        }
        return assetPath;
      }
    }
  };
};

export { buildWidgetOptions, oktaConfig };
